import { AUTHENTICATOR_APP_DOWNLOAD } from '../../../constants/ui.labels'
import {
  DOWNLOAD_AUTHENTICATOR_APP_APPLE_STORE,
  DOWNLOAD_AUTHENTICATOR_APP_GOOGLE_PLAY,
} from '../../../constants/links'
import Link from '@talkdesk/cobalt-react-link'
import Image from '@talkdesk/cobalt-react-image'
import { Text } from '@talkdesk/cobalt-react-typography'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'
import Flex from '@talkdesk/cobalt-react-flex'
import Card from '@talkdesk/cobalt-react-card'
import Box from '@talkdesk/cobalt-react-box'

const DownloadAppLink = ({ url, img }) => (
  <Link target='_blank' href={url}>
    <Image src={img} width={130} alt='' />
  </Link>
)

export const AuthenticatorAppDownload = ({
  googlePlayBadgeUrl,
  appleStoreBadgeUrl,
}) => {
  const theme = useTheme()
  return (
    <Card outlined>
      <Box paddingX='5' paddingY='10'>
        <Flex direction='column' gap='4' alignX='center' alignY='center'>
          <Text size='small' textAlign='center' color={theme.gray600}>
            {AUTHENTICATOR_APP_DOWNLOAD}
          </Text>
          <Flex alignX='space-around' alignY='center' gap='5' width='100%'>
            <Box>
              <DownloadAppLink
                url={DOWNLOAD_AUTHENTICATOR_APP_APPLE_STORE}
                img={appleStoreBadgeUrl}
              />
            </Box>
            <Box>
              <DownloadAppLink
                url={DOWNLOAD_AUTHENTICATOR_APP_GOOGLE_PLAY}
                img={googlePlayBadgeUrl}
              />
            </Box>
          </Flex>
        </Flex>
      </Box>
    </Card>
  )
}
